var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _path9, _path0, _path1, _path10, _path11, _path12, _ellipse8, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNodata = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 526.08 398.98"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".nodata_svg__a{fill:#dbdbdb}.nodata_svg__b{fill:#b3b3b3}.nodata_svg__d{fill:#d1d1d1}.nodata_svg__f{fill:#ccc}.nodata_svg__i{fill:#e6e6e6}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m294.394 213.483 8.767-3.19 30.81 84.647-8.768 3.19zM193.258 298.134l-8.767-3.191 30.81-84.648 8.766 3.191z",
  className: "nodata_svg__a"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M255.23 209.23h8v62.36h-8z",
  className: "nodata_svg__b"
})), /*#__PURE__*/React.createElement("path", {
  d: "M142.71 85.03h232.74v156.9H142.71z",
  style: {
    fill: "#fff",
    stroke: "#dbdbdb",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }
}), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M199.96 242.25h118.56v11.96H199.96z",
  className: "nodata_svg__d"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M250.11 71.9h18.25v13.14h-18.25z",
  className: "nodata_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  d: "m233.65 307.65-2.43-.52-8.11-4.23-6.72-10.9-1.17-6.83s1.83-7.67 2.33-8a39 39 0 0 1 4.5-3.33c1.83-1 8.33-2.5 8.33-2.5l7.17-14.67 5.61-28 .68-3.13 1.09-2.85.95-2.8-4.16-7.52s-3.67-7.19-3.83-9.09-1-7.91-1-8.74.83-6 .83-6l1.8-3.78 3.37-2.6 18.67-1.78 9.83 3.25 3.27 2.43 3.73 2.32 2.5 6.5-3.83 13.83-3.5 6.17-2 2.17.21 5.65 1.92 6 3.54 22.53 5 13.83 4 6.17 5.5 1.5 3.83 1.67a42 42 0 0 1 3.83 3.17 14.9 14.9 0 0 1 1.67 3.83c0 .5-.67 3.67 0 5.17s-1.33 7-1.33 7l-3.46 4.39-2.21 3.61-4.6 4.3-3.4 1.88-4.67 1.65-14.22 7.6s-17.37-1.43-19-1.67-6.16-3-7.66-5.15-6.86-2.53-6.86-2.53",
  style: {
    fill: "#fff"
  }
}), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M282.1 307.65c-2.9 3.56-12 6.17-22.81 6.17s-19.91-2.6-22.81-6.17c-20.18 1-34.3 3.41-34.3 6.17 0 3.72 25.56 6.73 57.08 6.73s57.08-3 57.08-6.73c.01-2.76-14.08-5.13-34.24-6.17",
  className: "nodata_svg__f"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M259.33 181.73c6.74.34 12.49 2 15.32 4.25-.39-3.9-7.49-7.3-16.45-7.75-9.42-.47-17.33 2.51-17.66 6.65l2.1.1c2.86-2.25 9.36-3.62 16.69-3.25M285.83 185.08c-6.06-1.12-6.81 1.62-9.82.86l-2 10.24-2.83 9.17s1.6.89 3.35 1.75a6.2 6.2 0 0 1-1.91 6.34c-.51.45-3.81 7.8-4.46 8.17 4.75-3.68 7.78-8.39 8.7-8.7 1.72-.59 2.24-2.62 2.33-4.27a29.5 29.5 0 0 0 4.92-2.42l3.83-4.5 4.18-5.65 4.18-5.65a22.83 22.83 0 0 0-10.47-5.34M241.58 205.57c1.53-.77 2.81-1.48 2.81-1.48l-2.83-9.17-2-10.24c-3 .76-3.76-2-9.82-.86a22.83 22.83 0 0 0-10.44 5.32l4.18 5.65 4.18 5.65 3.83 4.5s4 2.42 5.37 2.5h.14a6.52 6.52 0 0 0 2.38 4.39c1.5 1.21 6.42 9.12 8.84 9.74-.66-.42-4.06-8.59-4.58-9.09a7.48 7.48 0 0 1-2.06-6.91",
  className: "nodata_svg__b"
})), /*#__PURE__*/React.createElement("path", {
  d: "m271.76 222.62-2.16 3.9c-2.48 2.81-6.93 3.81-11.25 3.77s-8.77-1-11.25-3.77l-2.16-3.9-1.09 2.85c2.78 6.43 8.07 8.68 14.51 9.11 6.44-.43 11.73-2.68 14.51-9.11Z",
  style: {
    fill: "#9f9fa0"
  }
}), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M286.81 297.91c-.36-.6-1.2 3.48-2.19 4-.68.37-.05.18-1.64 1.22a61.5 61.5 0 0 1-7.44 4.24 27.5 27.5 0 0 1-6.94 2.24c-3.38.68-15.06 1-18.44.28a27.5 27.5 0 0 1-6.94-2.24 61.5 61.5 0 0 1-7.44-4.24c-1.59-1-1-.84-1.64-1.22-1-.54-1.83-4.62-2.19-4a5.67 5.67 0 0 0 .68 6c1.27 1.77 2.51 2.2 5.84 4.49 6 4.15 5 4.77 8.77 6.73a38 38 0 0 0 4 1.74c-.18 4.53-6.64 9.18-16 11a37.6 37.6 0 0 1-15.33 0 4.9 4.9 0 0 0 .4 1.72c2.27 5.13 13 7.53 23.89 5.36 7.12-1.42 20.33-13.42 24.17-18.55a8.6 8.6 0 0 1-2.16.55c.84-.26 1.65-.56 2.38-.85l-.22.3a2.1 2.1 0 0 0 .74-.51c1.3-.55 2.25-1 2.42-1.12 3.79-2 2.72-2.59 8.77-6.73 3.34-2.29 4.57-2.72 5.84-4.49a5.67 5.67 0 0 0 .67-5.92",
  className: "nodata_svg__b"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M301.12 277.19a14.25 14.25 0 0 0-9.3-5.78c0-.1-3.08-.88-5-1.4-1.66-4.66-3.52-9.58-4.21-11.39-11.86-30.76-7.78-34.94-9.83-27.65-.89 1.08-.28 4 .73 7.56-2 2.47 1 4.36-2.38 11-3.44 6.81-5.21 10.25-7.78 11.91-2.21 1.43-3.59 1.11-5 1.2-1.38-.09-2.76.23-5-1.2-2.58-1.67-4.35-5.1-7.78-11.91-3.28-6.51-.51-8.45-2.28-10.86 1-3.65 1.66-6.59.76-7.68-2.06-7.29 2-3.11-9.83 27.65-.7 1.81-2.56 6.76-4.22 11.42-1.94.52-4.88 1.27-4.89 1.37a14.25 14.25 0 0 0-9.3 5.78 15.13 15.13 0 0 0-2.49 10.38 27 27 0 0 0 9.77 15.33 28.5 28.5 0 0 0 5.64 3.5 22 22 0 0 0 3.39.93 31.1 31.1 0 0 1-10.12-8.77l-2.5-4.08c-2.84-5.73-3.09-11.76-.06-16.08 2-2.87 5.62-4.66 9.49-5.22-1.62 4.69-2.66 8.13-1.42 6l6.24-7.64a29.4 29.4 0 0 0 3.38-6.18c.38.52 1 1.2 3.69 3.16 4 3 1.78 8.37 6 14.3.83 1.17 6.42 8.83 11.56 8.6 5.14.24 10.73-7.43 11.56-8.6 4.21-5.93 1.94-11.31 6-14.3 2.85-2.1 3.4-2.73 3.77-3.27a30 30 0 0 0 3.43 6.29l6.24 7.64c1.24 2.1.2-1.35-1.43-6 3.91.54 7.58 2.34 9.61 5.23 3 4.33 2.78 10.36-.06 16.08l-2.5 4.08a31.1 31.1 0 0 1-10.17 8.74 22 22 0 0 0 3.39-.93 28.5 28.5 0 0 0 5.64-3.5 27 27 0 0 0 9.77-15.33 15.13 15.13 0 0 0-2.51-10.38",
  className: "nodata_svg__b"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 404.04,
  cy: 310.59,
  className: "nodata_svg__f",
  rx: 46.79,
  ry: 7.42
})), /*#__PURE__*/React.createElement("path", {
  d: "M427.27 297.91c-14.5-1.76-22.63-2.75-33.69-2.61-5 .06-15.68.2-23.14 2.31-4.26 1.21-9.73 3.69-5.79 5.49a25.2 25.2 0 0 0 8.4 1.58c3.84.13 5.13-.61 8.45-.35 3 .23 5.81 1.14 6.13 2 .18.47-.51.68-4 2.27-3.68 1.67-3.91 1.88-4 2.12-.41 1 1.81 2.29 5 3 1.3.28 5.67 1.09 25.9-.45 12.7-1 19-1.44 23.71-2.6 1.76-.43 12.36-3.05 10.33-6.85-.27-.51-1.41-2.45-7.2-4.08a66.6 66.6 0 0 0-10.1-1.83Z",
  style: {
    fill: "#fff",
    strokeMiterlimit: 10,
    stroke: "#bcbcbc"
  }
}), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 396.56,
  cy: 308.63,
  className: "nodata_svg__a",
  rx: 5.48,
  ry: 1.96
})), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 414.25,
  cy: 308.63,
  className: "nodata_svg__a",
  rx: 5.48,
  ry: 1.96
})), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 431.94,
  cy: 305.45,
  className: "nodata_svg__a",
  rx: 5.48,
  ry: 1.96
})), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 414.25,
  cy: 301.59,
  className: "nodata_svg__a",
  rx: 5.48,
  ry: 1.96
})), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 397.92,
  cy: 299.64,
  className: "nodata_svg__a",
  rx: 5.48,
  ry: 1.96
})), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 381.6,
  cy: 299.64,
  className: "nodata_svg__a",
  rx: 5.48,
  ry: 1.96
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M102.26 257.77c-2.83-11.9-6.41-21.33-8-21s-.61 10.16 2.21 22.06c.43 1.81.88 3.56 1.33 5.23h-.09l12.78 46.88 2.62-.46-9.59-47c-.38-1.81-.79-3.73-1.26-5.71",
  className: "nodata_svg__d"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M114.78 245.41c0-13-1.82-23.5-4.07-23.5s-4.07 10.52-4.07 23.5c0 2 0 3.89.12 5.72h-.12l2.23 51.42h3.68l2.09-50.92c.09-1.98.14-4.06.14-6.22",
  className: "nodata_svg__d"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "m114.8 215.3-3.27-8.07-.93 1.82-.74-1.82-2.08 4.08s-3.68 6.49-1.46 10.68a4.93 4.93 0 0 0 5.09 2.44c2.94.57 6.06-1.67 3.39-9.13M90.31 230.66l.1-7.73.93 1.58v-1.74l2.08 3.53s3.52 5.58 3.17 9.64c-.15 1.74-1.23 2.92-2.37 2.75-1.53.81-3.81-.92-3.91-8.03",
  className: "nodata_svg__i"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "m123.46 227.497 5.155.682-10.642 80.51-5.155-.682z",
  className: "nodata_svg__d"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "m128.61 228.18-5.15-.68 4.06-11.63z",
  className: "nodata_svg__i"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "m127.76 220.53-1.73-.23 1.36-3.89",
  className: "nodata_svg__d"
})), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 110.71,
  cy: 309.08,
  className: "nodata_svg__f",
  rx: 23.76,
  ry: 5.42
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M126.04 308.65H94.65l-2.94-45.73h36z",
  className: "nodata_svg__i"
})));
export default SvgNodata;